/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_Event_DurationInputs */



/**
* | output |
* | --- |
* | "Minimum Event Duration (sec)" |
*
* @param {Min_Event_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const min_event_duration = /** @type {((inputs?: Min_Event_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_Event_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée minimale d’un événement (s)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestdauer des Ereignisses (Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata minima dell'evento (sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная продолжительность события (сек)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración mínima del evento (seg.)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最短事件持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम आयोजन अवधि (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração mínima do evento (segundos)")
	return /** @type {LocalizedString} */ ("Minimum Event Duration (sec)")
});